(function (){
    'use strict';

    angular
        .module('app')
        .config(routeSetup);

    routeSetup.$inject = ['$stateProvider', '$urlRouterProvider', 'jwtInterceptorProvider']

    function routeSetup ($stateProvider, $urlRouterProvider, ) {

        $stateProvider
            .state('root', {
                abstract: true,
                views: {
                    'header-view': {
                        templateUrl: 'templates/wrapper/header.html',
                        controller: 'RootController',
                        controllerAs: 'root'
                    },
                    'menu-view': {
                        templateUrl: 'templates/wrapper/menu.html',
                        controller: 'RootController',
                        controllerAs: 'root'
                    },
                    'top-view': {
                        templateUrl: 'templates/wrapper/theme-wrapper.html',
                        controller: 'RootController',
                        controllerAs: 'root'
                    },
                },
                resolve: {
                    CurrentUser: ['AuthService', function (AuthService) {
                        return AuthService.getCurrentUser();
                    }],
                    // role: ['$q', 'AclService', 'AuthService', function ($q, AclService, AuthService) {
                    //     return AuthService.getRole()
                    //         .then(function (role) {
                    //             if (role) {
                    //                 AclService.attachRole(role);
                    //                 return role;
                    //             } else {
                    //                 console.error(JSON.stringify('no role set'));
                    //                 return $q.reject('No role.');
                    //             }
                    //         });
                    // }]
                }
            })
            // .state('root.dashboard', {
            //     url: '/dashboard',
            //     views: {
            //         'inner-view@root': {
            //             template: '<div></div>'
            //         }
            //     }
            // })
            .state('root.dashboard', {
                url: '/dashboard',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/dashboard/dashboard.html',
                        controller: 'PhysicalFairDashboardController',
                        controllerAs: 'physicalFairDashboard'
                    }
                }
            });

        $urlRouterProvider.otherwise("/auth/login");
    }

})();